<template>
  <div>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-menu
              ref="menuDateTo"
              v-model="menuDateTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateTo | periodFormat"
                  :label="$t('DATA_TABLE.FILTER')"
                  append-icon="mdi-calendar"
                  clearable
                  readonly
                  role="button"
                  @click:clear="clear_to"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="dateTo"
                type="month"
                min="1940-01-01"
                @change="saveDateto"
              ></v-date-picker>
            </v-menu>
          </td>
          <td>
            <v-autocomplete
              v-model="filter.employee"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="employee"
              :items="employees"
              :loading="loading"
              item-text="name"
              item-value="name"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              clearable
              @change="changeExportOptions"
            ></v-autocomplete>
          </td>
          <td>
            <v-select
              v-model="filter.status"
              :items="payrollStatuses"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              chips
              small-chips
              multiple
              clearable
              @change="changeExportOptions"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
            </v-select>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-btn color="primary" depressed @click.prevent="refreshData(true)">
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { periodFormat } from '@/modules/_global/filters';
import { debounce, cloneDeep, isEmpty } from 'lodash';
import { types } from '@/modules/ereporter/common/types.js';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'TasksListFilter',

  filters: {
    periodFormat
  },

  data: () => ({
    unwatch: null,
    options: {},
    delay: 0,
    payrollStatuses: [],
    types: types,

    employee: null,
    order_number: null,
    customer: null,
    employees: [],
    order_numbers: [],
    customers: [],

    filter: {},

    menuDateTo: false,
    dateTo: null,

    expensiveFunc: null,

    timeClickFindButton: null,
    optionsExport: null
  }),

  computed: {
    ...mapState(['loading']),
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    },
    headers() {
      return [
        {
          text: this.$t('EREPORTER.PERIOD'),
          sortable: false
        },
        {
          text: this.$t('EMPLOYEES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    },
    prevParams() {
      return this.$store.getters['ereporter/EXPENSES_FILTER'];
    }
  },

  watch: {
    dateTo(val) {
      if (val) {
        this.filter.period = val;
      } else {
        this.filter.period = null;
      }

      this.changeExportOptions();
    },

    employee(val) {
      if (val !== this.filter.employee && !isEmpty(val)) {
        this.expensiveFunc = this.getDataEmployees;
        this.debouncedRequest();
      }
    }
  },

  created() {
    if (!isEmpty(this.prevParams)) {
      this.filter = cloneDeep(this.prevParams);
      this.employee = this.prevParams.employee;
      this.getDataEmployees();
      this.dateTo = this.filter.period;
    }

    this.refreshData();
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.refreshData();
          this.setData();
        }
      }
    );
    this.setDelay(500);
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    ...mapActions('ereporter', ['getFilteredPayrollEmployee']),
    ...mapCacheActions('ereporter', ['getPayrollStatuses']),
    clear_to() {
      this.dateTo = null;
    },

    saveDateto(date) {
      this.$refs.menuDateTo.save(date);
    },

    expensiveOperation: function() {
      return this.debouncedRequest();
    },
    refreshData(clickedFindButton = false) {
      this.changeExportOptions();

      if (clickedFindButton) {
        this.changeExportOptions();

        this.timeClickFindButton = Date.now();

        this.optionsExport.timeClickFindButton = this.timeClickFindButton;
        this.$emit('setExportOptions', this.optionsExport);
      }

      this.$emit('setRequest', cloneDeep(this.filter));
    },
    changeExportOptions() {
      this.optionsExport = null;
      this.optionsExport = cloneDeep(this.filter);
      this.optionsExport.timeChangeExportOptions = Date.now();
      this.optionsExport.timeClickFindButton = this.timeClickFindButton;

      this.$emit('setExportOptions', this.optionsExport);
    },
    setDelay(v) {
      this.delay = v;
    },
    setData() {
      this.getPayrollStatuses()
        .then(({ data }) => {
          this.payrollStatuses = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataEmployees() {
      this.getFilteredPayrollEmployee({ search: this.employee })
        .then(({ data }) => {
          this.employees = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    remove(item) {
      const index = this.filter.status.indexOf(item.id);
      if (index >= 0) this.filter.status.splice(index, 1);
    },
    reset() {
      this.employee = null;
      this.order_number = null;
      this.customer = null;
      this.filter = {};
      this.menuDateTo = false;
      this.dateTo = null;
      this.expensiveFunc = null;

      this.refreshData();
    }
  }
};
</script>
